import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Form } from "antd";

import {
    usersSetModePartnerModal,
    usersSetSelectedPartner,
    usersSetShowPartnerModal,
} from '../../../../store/actions/usersActions';

import AccountModal from "../../../../commons/components/AccountModal"
import AccountSelectSearch from "../../../../commons/components/AccountSelectSearch";
import Loading from "../../../../commons/components/loading";
import RolesSelect from "../../../../commons/components/RolesSelect";

import partnerModalModes from './partnerModalModes'
import Http from "../../../../commons/utils/Http";
import Message from "../../../../commons/utils/message";
import Permissions from "../../../../commons/utils/permissions";

function PartnerModal({ onSave }) {
    const dispatch = useDispatch();
    const { screens } = useSelector(state => state.userLogin);
    const { showPartnerModal, modePartnerModal, selectedUser, selectedPartner } = useSelector((state) => state.users);
    const [permissions] = useState([]);
    const [loading, setLoading] = useState(false);

    const [partner, setPartner] = useState({});
    const [errorPartner, setErrorPartner] = useState("");
    const [partners, setPartners] = useState([]);

    const [roleTreeData, setRoleTreeData] = useState([]);
    const [roleTreeExpandedItems, setRoleTreeExpandedItems] = useState([]);
    const [roleTreeSelectedItems, setRoleTreeSelectedItems] = useState([]);
    const [errorRoleSelect, setErrorRoleSelect] = useState("");

    useEffect(() => {
        permissions.pop();
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/users") {
                    screen.functions.map(_function => {
                        if (!permissions.find(permission => permission.function_id == _function.function_id)) {
                            permissions.push(_function);
                        }
                    })
                }
            });

            getRoleTreeData();
        }
    }, [screens]);

    useEffect(() => {
        if (selectedPartner.id && modePartnerModal != partnerModalModes.INSERT) {
            getRolesChecked(selectedPartner.applications);
            setPartner(formatPartnerData(selectedPartner));
        }
    }, [selectedPartner]);

    function getRolesChecked(applications) {
        let array = [];
        applications.forEach((application) => {
            application.roles.forEach((role) => {
                array.push(application.id + '-' + role.id);
            });
        });

        setRoleTreeSelectedItems(array);
    }

    function searchPartners(search) {
        Http.get(`/partners/search?search=${search}`, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    setPartners(formatSelectPartnersData(responseData.data));
                }
            }).catch(err => {
                setPartners([]);
            })
    }

    function getRoleTreeData() {
        setLoading(true);

        const enableOnlyHelpCenter = permissions.find(_function => _function.function_id === Permissions.LISTAR_ROLES_CENTRAL_AJUDA);
        const enableCompleteRoles = permissions.find(_function => _function.function_id === Permissions.LISTAR_ROLES_COMPLETO);

        Http.get(`/roles/roles-and-applications`, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {

                    let applicationRoles = [];
                    responseData.data.forEach((dataItem) => {
                        if (dataItem.partner_scoped === true) {
                            let application = {
                                title: dataItem.name,
                                key: dataItem.id,
                                id: dataItem.id,
                                disabled: (enableOnlyHelpCenter && dataItem.id !== 10) && !enableCompleteRoles,
                            };
                            let roles = [];
                            dataItem.roles.forEach((dataRole) => {
                                let role = {
                                    title: dataRole.name,
                                    key: dataItem.id + '-' + dataRole.id,
                                    id: dataRole.id,
                                    disabled: (enableOnlyHelpCenter && dataItem.id !== 10) && !enableCompleteRoles,
                                }
                                roles.push(role);
                            })
                            application.children = roles;
                            applicationRoles.push(application);
                        }
                    })
                    
                    setRoleTreeData(applicationRoles)
                    setLoading(false);
                }
            }).catch(err => {
                setRoleTreeData([]);
                setLoading(false);
            })
    }

    async function findPartnerPermissions(user_id, partner_id) {
        try {
            const response = await Http.get(`/partners/puar?user_id=${user_id}&partner_id=${partner_id}`, Http.headers);
            return response.data
        } catch (error) {
            const responseData = error.response ? error.response.data : null;

            if (responseData && responseData.response.status == 414) {
                return responseData.data;
            }

            Message.showError("Erro ao localizar permissões para este parceiro");
        }
    }

    async function insertPartnerPermissions(body) {
        try {
            let response = await Http.post(`/users`, body, Http.headers);
            return response
        } catch (error) {
            if (error.response) {
                Message.showError(error.response.data.response.message);
            }
            else {
                Message.showError("Erro ao inserir permissões para este parceiro");
            }
        }
    }

    function formatPartnerData(partner) {
        let item = {};
        item.label = `${partner.codparc + " - " + partner.trading_name}`;
        item.value = partner.id;
        return item;
    }

    function formatSelectPartnersData(partners) {
        let array = [];
        if (partners) {
            partners.forEach((dataItem) => {
                let item = {}
                if (dataItem.id != 1 && dataItem.trading_name != "PARCEIRO DEFAULT") {
                    item.label = `${dataItem.codparc + " - " + dataItem.trading_name}`;
                    item.value = dataItem.id;
                    array.push(item)
                }
            })
        }
        return array;
    }

    function validateForm() {
        let valid = true;

        if (!partner.value) {
            setErrorPartner("Informe um parceiro");
            valid = false;
        }

        if (roleTreeSelectedItems.length == 0) {
            setErrorRoleSelect("Informe uma role");
            valid = false;
        }

        return valid;
    }

    function renderButtons() {
        if (modePartnerModal == partnerModalModes.VIEW) {
            return (
                <button key="cancel" onClick={handleClear} className="ant-btn ant-btn-primary">Ok</button>
            )
        } else {
            return (
                <>
                    <button key="cancel" onClick={handleClear} className="ant-btn">Cancelar</button>
                    <button key="confirm" onClick={handleSave} className="ant-btn ant-btn-primary">Salvar</button>
                </>
            )
        }
    }

    async function handleSave() {
        if (validateForm()) {

            let body = {
                "email": selectedUser.email,
                "partner_id": partner.value,
            };

            let bodyRoles = [];
            roleTreeData.map((application) => {
                application.children.map((role) => {
                    if (roleTreeSelectedItems.includes(role.key)) {
                        bodyRoles.push({
                            "partner_id": partner.value,
                            "application_id": application.id,
                            "role_id": role.id,
                        })
                    }
                })
            })

            setLoading(true);
            if (selectedPartner.id && modePartnerModal == partnerModalModes.EDIT) {
                body.isAccountWeb = true;
            } else {
                const responseFindUser = await findPartnerPermissions(selectedUser.id, partner.value);
                if (responseFindUser.data && responseFindUser.data.length > 0) {
                    setErrorPartner("Parceiro já vinculado a esse usuário");
                    setLoading(false);
                    return;
                }

            }

            body.roles = bodyRoles;

            const responseInsert = await insertPartnerPermissions(body);
            if (responseInsert && !responseInsert.data.response.error) {
                Message.showSuccess(responseInsert.data.response.message);
                onSave();
                handleClear();
            }
            setLoading(false);
        }
    }

    function handleClear() {
        dispatch(usersSetShowPartnerModal(false));
        dispatch(usersSetModePartnerModal(null));
        dispatch(usersSetSelectedPartner({}));

        setPartner({});
        setErrorPartner("");

        setRoleTreeSelectedItems([]);
        setErrorRoleSelect("");

        setPartners([]);
        setRoleTreeExpandedItems([]);

        setLoading(false);
    }

    function handleOnSearchPartner(search) {
        searchPartners(search);
        setErrorPartner("");
    }

    function handleOnChangePartner(partnerId) {
        setPartner(partners.find(partner => partner.value == partnerId));
        setErrorPartner("");
    }

    function onRoleCheck(checkedKeys) {
        setRoleTreeSelectedItems(checkedKeys);
        setErrorRoleSelect("");
    };

    function renderForm() {
        if (loading) {
            return (
                <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                    <Loading width={50} height={50} />
                </div>
            )
        } else {
            return (
                <Form>
                    <Form.Item>
                        <AccountSelectSearch
                            placeholder={"Selecionar Parceiro"}
                            data={partners}
                            value={partner.label}
                            onSearch={handleOnSearchPartner}
                            onChange={handleOnChangePartner}
                            error={errorPartner}
                            showSearch={true}
                            allowClear={false}
                            disabled={selectedPartner.id ? true : false}
                        />
                    </Form.Item>
                    <Form.Item>
                        <RolesSelect
                            checkable={true}
                            onCheck={onRoleCheck}
                            checkedKeys={roleTreeSelectedItems}
                            expandedKeys={roleTreeExpandedItems}
                            treeData={roleTreeData}
                            error={errorRoleSelect}
                            onExpand={(items) => setRoleTreeExpandedItems(items)}
                        />
                    </Form.Item>
                </Form>
            )
        }
    }

    return (
        <AccountModal
            visible={showPartnerModal}
            title={"Permissões do parceiro"}
            onCancel={handleClear}
            footer={renderButtons()}>
            {renderForm()}
        </AccountModal>
    )
}

export default PartnerModal;

